import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import { drawerTransition, modalTransitionDuration, backdropTransition, transitionDuration } from '../../../../../Util/PageTransitions'
import './AddSponsor.css'
import CornerCloseButton from '../../../../../Util/CornerCloseButton/CornerCloseButton'
import { config } from '../../../../../config'
import WarningDialogue from '../../../../../Util/WarningDialogue'
import axiosApi from '../../../../../core/interceptor/interceptor'
import defaultImg from '../../../../../assets/default-add-img.png'
import { messages } from '../../../../../messages'
import CustomSelect from '../../../../../Util/CustomSelect/CustomSelect'
import { HOSTED_BY } from '../../../../../Util/helper'

export default function AddSponsor(props) {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState(false);
  const [selectedFile, setSelectedFile] = useState('');
  const [img, setImg] = useState(props.itemDetails.image ? <img src={`${config.cdnUrl}/sponsors/${props.itemDetails.image}`} alt={props.itemDetails.image} /> : <img src={defaultImg} alt='default-add-img' />);
  const [data, setData] = useState({
    image: props.itemDetails.image,
    name: props.itemDetails.name,
    hyper_link: props.itemDetails.hyper_link,
    type: props.itemDetails.type
  });
  const [errors, setErrors] = useState({
    name: '',
    description: '',
    image: ''
  });
  const urlPattern = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  useEffect(() => {
    handleValidation();
    //eslint-disable-next-line
  }, [data]);

  const cancelChangesHandler = () => {
    props.onClose();
  }

  const handleFormChange = (e) => {
    if (e.target.type === 'file') {
      const file = e.target.files[0];
      if (file) {
        setSelectedFile(file);
        setImg(<img src={`${URL.createObjectURL(e.target.files[0])}`} alt='' />);
        setData((prev) => ({
          ...prev,
          image: file?.name
        }))
      }
    } else {
      setData((previousFormData) => ({
        ...previousFormData,
        [e.target.name]: e.target.value,
      }));
    }
  }

  const handleSubmit = () => {
    setFormSubmitted(true);
    if (handleValidation()) {
      const formData = new FormData();
      formData.append('name', data.name);
      formData.append('hyper_link', data.hyper_link);
      formData.append('image', data.image);
      formData.append('type', data.type);
      if (selectedFile && selectedFile.name) {
        formData.append('file', selectedFile);
      }
      if (props.isNewItem) {
        axiosApi.post(`${config.apiUrl}/sponsor/create`, formData)
          .then((res) => {
            props.onClose();
            props.isAddOrEdit(true);
          })
      } else {
        axiosApi.put(`${config.apiUrl}/sponsor/${props.itemDetails.id}`, formData)
          .then((res) => {
            props.onClose();
            props.isAddOrEdit(true);
          })
      }
    }
  }

  const handleValidation = () => {
    let errArray = {};
    let formIsValid = true;

    if (!data['name']?.trim()) {
      formIsValid = false;
      errArray['name'] = messages && messages.emptyField;
    }
    if (!data['image']) {
      formIsValid = false;
      errArray["image"] = messages && messages.uploadFile;
    }
    if (!data['type']) {
      formIsValid = false;
      errArray["type"] = messages && messages.advertisementForError;
    }
    if (data['hyper_link'] && !urlPattern.test(data['hyper_link'])) {
      formIsValid = false;
      errArray['hyper_link'] = messages && messages.invlaidUrl;
    }
    setErrors(errArray);
    return formIsValid;
  }
  return <>
    <motion.div className='adminItemDrawerPageContainer'>
      <form encType="multipart/form-data">
        <motion.div className='adminBackdrop' onMouseDown={cancelChangesHandler} initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }} />
        <motion.div className='adminItemDrawer' initial={drawerTransition.initial} animate={drawerTransition.in} exit={drawerTransition.out} transition={{ duration: modalTransitionDuration }}>
          <div className={`flex-container `}>
            <div className="top-blk">
              <CornerCloseButton onClick={cancelChangesHandler} />
              <div className="adminItemDrawerPictureContainer-outer">
                <div className='adminItemDrawerPictureContainer sidebar-add-img'>
                  <label htmlFor="img" className='adminItemDrawerPicture'>
                    {img}
                  </label>
                  <div className="buttonblock">
                    <label htmlFor="add-img" className='buttonStyle changeimagebutton btn' style={{ left: '10px' }}>{(props.itemDetails.image === '' || props.itemDetails.image == null) && !data.image ? 'Add Image' : 'Change Image'}
                      <input type='file' name='image' className='siteInfoImageUploader' onChange={(e) => handleFormChange(e)} id="add-img" accept="image/*" ></input>
                    </label>
                    <span className="error">{(formSubmitted && errors["image"])}</span>
                  </div>
                </div>
                <div className={`adminItemDrawerDetailsContainer adminAddItemsFormBlockLatest FormBlockLatest-switch`}>
                  <div className='adminAddItemsFormBlock '>
                    <div className="adminAddItemsFormBlockRow">
                      <div className="adminAddItemsFormBlockCol half">
                        <div className="input-outer-block">
                          <label>{'Name'}</label>
                          <input type='text' name="name"
                            value={data['name']}
                            onChange={(e) => handleFormChange(e)} />
                          <span className="error">{formSubmitted && errors['name']}</span>
                        </div>
                      </div>
                      <div className="adminAddItemsFormBlockCol half">
                        <div className="input-outer-block">
                          <label>{'URL'}</label>
                          <input type='text' name="hyper_link"
                            placeholder='https://example.com'
                            value={data['hyper_link']}
                            onChange={(e) => handleFormChange(e)}
                            pattern={urlPattern}
                            required
                          />
                          {/* <span className="error">{formSubmitted && errors['hyper_link']}</span> */}
                        </div>
                      </div>
                      <div className="adminAddItemsFormBlockCol half">
                        <div className="input-outer-block">
                          <CustomSelect className="mh-32"
                            uniqueKey={'Ad-type'}
                            required={true}
                            data={[
                              {
                                id: 'cleveland',
                                name: 'Cleveland'
                              },
                              {
                                id: 'mulberry',
                                name: 'Mulberry'
                              },
                              {
                                id: 'both',
                                name: 'Both'
                              }
                            ]}
                            label={'Show Ad for'}
                            placeholder={data.type ? HOSTED_BY[data.type] : 'Select...'}
                            onSelect={(e) => e && handleFormChange({
                              target: {
                                name: 'type',
                                value: e.id
                              }
                            })}
                            selector="name"
                          />
                          <span className="error">{formSubmitted && errors['type']}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='adminItemDrawerFooterContainer adminItemDrawerFooterContainerbtns'>
                  <div className="buttonblock">
                    <button className='btn' onClick={() => handleSubmit()} type='button'>Save</button>
                    <button className='btn white-btn' onMouseDown={cancelChangesHandler}>Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </form>
    </motion.div>

    <WarningDialogue
      isOpen={openWarningPopup}
      header={popupContent.header}
      description={popupContent.description}
      icon={popupContent.icon}
      action={popupContent.action}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}